import React from 'react';
import { Box } from '@mui/material';
import { INK, INK_LINE, INK_RAISED } from '../theme/kiff';

/**
 * Loading placeholders drawn in the exact geometry of the card they stand in
 * for — same keyline, same radius — so nothing jumps when the content lands.
 * The design rule they enforce: never a centred spinner on a blank page.
 */
const pulse = {
  animation: 'kiffPulse 1.4s ease-in-out infinite',
  '@keyframes kiffPulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.55 },
    '100%': { opacity: 1 },
  },
};

/** A single shimmering bar. `dark` variants sit on the ink dispatcher shell. */
export const SkeletonBlock = ({ width = '100%', height = 16, radius = 6, dark = false, sx }) => (
  <Box
    aria-hidden
    sx={{
      width,
      height,
      borderRadius: `${radius}px`,
      backgroundColor: dark ? '#332C26' : '#EFE7DC',
      ...pulse,
      ...sx,
    }}
  />
);

/** A card-shaped frame with the real keyline; compose SkeletonBlocks inside. */
export const SkeletonCard = ({ dark = false, children, sx }) => (
  <Box
    aria-hidden
    sx={{
      border: `2.5px solid ${dark ? INK_LINE : INK}`,
      borderRadius: '14px',
      backgroundColor: dark ? INK_RAISED : '#FFFFFF',
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      ...sx,
    }}
  >
    {children || (
      <>
        <SkeletonBlock width="40%" height={14} dark={dark} />
        <SkeletonBlock width="70%" height={24} dark={dark} />
        <SkeletonBlock width="55%" height={14} dark={dark} />
      </>
    )}
  </Box>
);
